export default __webpack_public_path__ + "static/font-58517ed912b7703ece657d82f62978da.woff";